import React, { useEffect, useRef } from "react";

const SDK_SRC = "https://sdk.sigmayan.com/webshop-sdk-client/pms-webshop.min.js";

const API_URL = "https://neo-payment.com";
const PUBLISHABLE_KEY = "pk_live_Mdx3tpQ2RhaWm1wl3YfQ59kx";

// Storefront affiché selon le domaine (sans le préfixe www.)
const STOREFRONTS = {
  "ragescream.com": "sf_d0d73da854",
  "standup-comedy.ch": "sf_ce5c4bb194",
};

const getStorefront = () =>
  STOREFRONTS[window.location.hostname.replace(/^www\./, "")];

// Chargement unique du script, partagé entre les montages du composant
let sdkPromise = null;
const loadSDK = () => {
  if (window.PmsWebshop) return Promise.resolve(window.PmsWebshop);
  if (!sdkPromise) {
    sdkPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = SDK_SRC;
      script.async = true;
      script.onload = () => resolve(window.PmsWebshop);
      script.onerror = () => {
        sdkPromise = null;
        reject(new Error("Erreur lors du chargement du Mayan SDK"));
      };
      document.body.appendChild(script);
    });
  }
  return sdkPromise;
};

/**
 * Widget storefront Mayan injecté directement dans la page (sans iframe)
 */
const MayanSDKContainer = () => {
  const containerRef = useRef(null);
  const storefront = getStorefront();

  useEffect(() => {
    if (!storefront) return;
    let cancelled = false;
    const container = containerRef.current;

    loadSDK()
      .then((PmsWebshop) => {
        if (cancelled || !container) return;
        container.innerHTML = "";
        PmsWebshop.mount(container, {
          apiUrl: API_URL,
          publishableKey: PUBLISHABLE_KEY,
          storefront,
        });
      })
      .catch((error) => console.error(error));

    return () => {
      cancelled = true;
      // Le SDK n'expose pas de destroy : on vide le conteneur
      if (container) container.innerHTML = "";
    };
  }, [storefront]);

  if (!storefront) return null;

  return (
    <div className="md:px-8 lg:px-12 mb-8">
      <div ref={containerRef} />
    </div>
  );
};

export default MayanSDKContainer;
